import confirmDialog from '@/store/modules/confirmDialog'
import DeleteConfirmationModal from "@/components/DeleteConfirmationModal"
var randomBytes = require('randombytes')
import store from "@/store/index";
export default {
  components: {
    DeleteConfirmationModal,
  },
  data() {
    return {
      DELETE_GUARD_NAMESPACE: null,
    }
  },
  created() {
    this.DELETE_GUARD_NAMESPACE = "deleteGuard-" + randomBytes(16).toString('hex');
    store.registerModule(this.DELETE_GUARD_NAMESPACE, confirmDialog)
  },
  beforeDestroy() {
    store.unregisterModule(this.DELETE_GUARD_NAMESPACE)
  },
};